import { render, staticRenderFns } from "./src/pages/lists.html?vue&type=template&id=16fa0d6d&scoped=true&"
import script from "./src/pages/lists.js?vue&type=script&lang=js&"
export * from "./src/pages/lists.js?vue&type=script&lang=js&"
import style0 from "./src/pages/lists.scss?vue&type=style&index=0&id=16fa0d6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa0d6d",
  null
  
)

export default component.exports